import type { ReactNode } from 'react';

export const symbol_settings_input_antenna: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M70-480q-12 0-21-8.5T41-509q6-86 42.5-161T179-800.5Q238-856 315.5-888T480-920q87 0 164.5 32T781-800.5Q840-745 876.5-670T919-509q1 12-8 20.5t-21 8.5q-13 0-21.5-9t-9.5-22q-12-148-120.5-248.5T480-860q-150 0-258.5 100.5T101-511q-1 13-9.5 22T70-480Zm175 0q-12 0-21-7.5t-8-18.5q10-102 85.5-170.5T480-745q103 0 178.5 68.5T744-506q1 11-8 18.5t-21 7.5q-12 0-21-7.5T683-507q-10-76-67.5-127T480-685q-78 0-135.5 51T277-507q-2 12-11 19.5t-21 7.5Zm235 296-99 99q-9 9-21 9t-21-9q-9-9-9-21t9-21l111-111v-156q-27-12-43.5-35.5T390-480q0-38 26-64t64-26q38 0 64 26t26 64q0 27-16.5 50.5T510-394v156l111 111q9 9 9 21t-9 21q-9 9-21 9t-21-9l-99-99Z"
		/>
	</svg>
);
